<template>
  <div class="flex flex-wrap">
    <confirm-dialogue ref="confirmDialogue"></confirm-dialogue>
    <div class="w-full px-4">
      <div class="relative flex flex-col min-w-0 break-words bg-white w-full mb-6 shadow-lg rounded">
        <div class="rounded-t bg-white mb-0 px-6 py-6">
          <div class="text-center flex justify-between">
            <h6 class="text-blueGray-700 text-xl font-bold">Pricings</h6>
            <div>
              <a class="bg-emerald-500 text-white active:bg-emerald-600 font-bold uppercase text-xs px-4 py-2 rounded shadow hover:shadow-md outline-none focus:outline-none mr-1 ease-linear transition-all duration-150"
                v-on:click="onClickAdd" href="#">
                Create New
              </a>

            </div>
          </div>
          <br />
          <hr />
          <div class="text-center flex justify-between py-6">
            <div class="w-full lg:w-12/12 flex flex-wrap">
              <div class="w-full lg:w-2/12 mr-3">
                <label class="block text-sm font-medium text-gray-700 mb-2">Client Name</label>
                <select v-model="filter.filter"
                  class="px-4 border-0 px-3 py-3 placeholder-blueGray-300 text-blueGray-600 bg-white rounded text-sm shadow focus:outline-none focus:ring w-full ease-linear transition-all duration-150">
                  <option v-for="(item, key) in filterClients['client_name']" :value="item" :key="key">
                    {{ item }}
                  </option>
                </select>
              </div>

              <a class="bg-emerald-500 text-white active:bg-emerald-600 font-bold uppercase text-xs px-4 py-3 mt-7 rounded shadow hover:shadow-md outline-none focus:outline-none mr-1 ease-linear transition-all duration-150"
                @click="search()">
                Search
              </a>
              <a class="bg-red-500 text-white active:bg-red-600 font-bold uppercase text-xs px-4 py-3 mt-7 rounded shadow hover:shadow-md outline-none focus:outline-none mr-1 ease-linear transition-all duration-150"
                @click="clear()">
                Clear
              </a>
            </div>
          </div>
        </div>
        <div class="block w-full overflow-x-auto">
          <!-- Projects table -->
          <table class="items-center w-full bg-transparent border-collapse">
            <thead>
              <tr>
                <th
                  class="px-6 bg-blueGray-50 text-blueGray-500 align-middle border border-solid border-blueGray-100 py-3 text-xs uppercase border-l-0 border-r-0 whitespace-nowrap font-semibold text-left">
                  ID
                </th>
                <th
                  class="px-6 bg-blueGray-50 text-blueGray-500 align-middle border border-solid border-blueGray-100 py-3 text-xs uppercase border-l-0 border-r-0 whitespace-nowrap font-semibold text-left">
                  Client Name
                </th>
                <th
                  class="px-6 bg-blueGray-50 text-blueGray-500 align-middle border border-solid border-blueGray-100 py-3 text-xs uppercase border-l-0 border-r-0 whitespace-nowrap font-semibold text-left">
                  Intention
                </th>
                <th
                  class="text-center px-6 bg-blueGray-50 text-blueGray-500 align-middle border border-solid border-blueGray-100 py-3 text-xs uppercase border-l-0 border-r-0 whitespace-nowrap font-semibold text-left">
                  Actions
                </th>
              </tr>
            </thead>
            <tbody>
              <tr v-for="item in clients" :key="item.id" data-bs-toggle="tooltip" :title="JSON.stringify({
                pricings: item.pricing_models
              }, null, 2)">
                <th class="border-t-0 px-6 align-middle border-l-0 border-r-0 text-xs whitespace-nowrap p-4 text-left">
                  {{ item.id }}
                </th>
                <td class="border-t-0 px-6 align-middle border-l-0 border-r-0 text-xs whitespace-nowrap p-4">
                  {{ item.client_name }}
                </td>
                <td class="border-t-0 px-6 align-middle border-l-0 border-r-0 text-xs whitespace-nowrap p-4">
                  {{ item.intention }}
                </td>
                <td class="border-t-0 px-6 align-middle border-l-0 border-r-0 text-xs whitespace-nowrap p-4 text-center">
                  <router-link :to="'/admin/pricings/' + item.id + '/edit'"
                    class="bg-emerald-500 text-white active:bg-emerald-600 font-bold uppercase text-xs px-4 py-2 rounded shadow hover:shadow-md outline-none focus:outline-none mr-1 ease-linear transition-all duration-150">Edit</router-link>
                  <a href="#" v-on:click="deleteItem(item)"
                    class="bg-red-500 text-white active:bg-red-600 font-bold uppercase text-xs px-4 py-2 rounded shadow hover:shadow-md outline-none focus:outline-none mr-1 ease-linear transition-all duration-150">Delete</a>
                </td>
              </tr>
            </tbody>
          </table>
          <Pagination :totalCounts="totalCounts" :onPageChange="handlePageChange" />

        </div>
      </div>
    </div>
  </div>
</template>
<script>
import PricingDataService from "@/services/PricingDataService";
import FilterDataService from "@/services/FilterDataService";
import { UseAppStore } from '@/stores/AppStore';
import Pagination from "@/components/Paginate/Pagination.vue";
import ConfirmDialogue from "@/components/ConfirmDialogue/ConfirmDialogue.vue";
import constants from "@/constants";
import ErrorHandler from "@/ErrorHandler";

export default {
  setup() {
    const appStore = UseAppStore();

    appStore.resetBreadcrumbs();
    appStore.putBreadcrumbs("dashboard", "Dashboard", "/admin/dashboard")
    appStore.putBreadcrumbs("pricings", "Pricing", "/admin/pricings")
    return {
      appStore
    }
  },
  components: {
    Pagination,
    ConfirmDialogue
  },
  data() {
    return {
      totalCounts: 0,
      clients: [],
      currentClient: {
        id: null,
        clientName: "",
        version: "",
        authToken: ""
      },
      currentIndex: -1,
      showModal: false,
      showModalDetail: false,
      alertType: '',
      alertMessage: '',
      pageType: 'Add',
      itemID: '',
      filter: {},
      filterClients: {},
      isExport: false,
      dataExport: []
    }
  },
  methods: {
    handlePageChange(page) {
      var payload = this.filter
      payload['limit'] = constants.pageLimit
      payload['page'] = page
      PricingDataService.search(payload)
        .then(response => {
          this.clients = response.data["data"]["pricings"];

        })
        .catch(e => {
          ErrorHandler(e);
        });
    },
    countDownTimer(countDown, callback) {
      if (countDown > 0) {
        setTimeout(() => {
          countDown -= 1
          this.countDownTimer(countDown, callback)
        }, 1000)
      } else {
        this.alertType = ''
        if (callback != undefined) {
          callback()
        }
      }
    },
    onClickAdd() {
      this.currentClient = {
        id: null,
        clientName: "",
        version: "",
        authToken: ""
      };
      this.showModal = !this.showModal;
      this.pageType = 'Add'
      this.$router.push(`/admin/pricings/new`)
    },
    retrieveApis() {
      PricingDataService.getAll()
        .then(response => {
          this.clients = response.data["data"]["pricings"];
          this.totalCounts = response.data["data"]["count"];
          console.log(response.data);
        })
        .catch(e => {
          ErrorHandler(e);
        });
      this.getClientNames()
    },
    getClientNames() {
      this.filter = {}
      this.filterClients['app_name'] = []
      FilterDataService.search(this.filter)
        .then(response => {
          this.filterClients['client_name'] = response.data["data"]["list"];
        })
        .catch(e => {
          ErrorHandler(e);
        });
    },
    search() {
      var payload = this.filter
      payload['limit'] = constants.pageLimit
      payload['page'] = 1
      PricingDataService.search(payload)
        .then(response => {
          this.clients = response.data["data"]["pricings"];
          this.totalCounts = response.data["data"]["count"];
        })
        .catch(e => {
          ErrorHandler(e);
        });
    },
    clear() {
      this.filter = {}
      this.filterClients = {}
      this.isExport = false
      this.retrieveApis();
    },
    async deleteItem(item) {
      const ok = await this.$refs.confirmDialogue.show({
        title: 'Attention',
        message: 'Are you sure you want to delete this item?',
        okButton: 'Delete',
      })

      if (ok) {
        PricingDataService.delete(item.id)
          .then(() => {
            this.alertType = 'Success'
            this.alertMessage = 'Pricing successfuly deleted'
            this.countDownTimer(3, this.retrieveApis)
          })
          .catch(e => {
            ErrorHandler(e);
          });
      }
    },
  },
  mounted() {
    this.retrieveApis();
  }
};
</script>
